import React from 'react';
import { SettingsProductsTab } from './SettingsProducts';
import { SettingsClientsTab } from './SettingsClients';

const Settings = () => {
  return <SettingsProductsTab />;
};

export const ProductsTab = () => {
  return <SettingsProductsTab />;
};

export const ClientsTab = () => {
  return <SettingsClientsTab />;
};

export default Settings;